const translations = {
  // Header / view badges
  prologueResults: 'RESULTADOS DEL PRÓLOGO',
  startPositionSelection: 'SELECCIÓN DE POSICIÓN DE SALIDA',
  appTitle: 'APLICACIÓN DE SELECCIÓN DE ORDEN DE SALIDA',
  pickOrder: 'Orden de Elección',
  poweredBy: 'Desarrollado por',

  // Toolbar tooltips
  zoomIn: 'Acercar',
  zoomOut: 'Alejar',
  configuration: 'Configuración',
  connectingZigbee: 'Conectando…',
  disconnectZigbee: 'Desconectar Zigbee',
  connectZigbee: 'Conectar Zigbee',
  zigbeeConnectError: 'Error al conectar el receptor Zigbee inalámbrico',
  zigbeeConnected: 'Receptor Zigbee inalámbrico conectado correctamente.',
  zigbeeDeviceNotPaired: 'El mando no está emparejado. Mantén pulsado el botón ARRIBA durante 10 segundos hasta que el LED parpadee. Cuando la luz permanezca fija, el mando está emparejado. Tiempo restante para emparejar:',
  zigbeeDevicePaired: 'Mando emparejado correctamente y conectado a la red.',
  zigbeePortInUse: 'El puerto serie ya está en uso. Cierre cualquier otra aplicación que lo utilice e inténtelo de nuevo.',
  exitEditMode: 'Salir del modo edición',
  editParticipants: 'Editar participantes',
  reset: 'Restablecer',
  switchToPrologue: 'Ver Resultados del Prólogo',
  switchToStart: 'Ver Selección de Posición de Salida',
  stopSession: 'Detener sesión',
  startSession: 'Iniciar sesión',
  sessionStarted: 'Sesión de posición de salida iniciada. ¡Pilotos, elijan su posición de salida!',
  loadFromAnube: 'Importar desde Anube',
  addParticipant: 'Añadir participante',

  // Session warning dialog
  startNewSession: 'Nueva Sesión',
  sessionWarningBody: '¿Ya existen posiciones iniciadas. ¿Iniciar una nueva sesión desde cero o continuar la actual?',
  newSession: 'Nueva Sesión',
  continueSession: 'Continuar',

  // DialogConfirm defaults
  resetTitle: 'Restablecer Orden de Salida',
  resetBody: 'Todos los participantes y datos de la sesión se eliminarán permanentemente.',
  resetConfirm: 'Eliminar Todo',
  warningCannotBeUndone: 'Esta acción no se puede deshacer.',
  cancel: 'Cancelar',
  confirm: 'Confirmar',

  // AddParticipantModal / EditParticipantModal shared
  brand: 'Marca',
  driver: 'Piloto',
  driverNamePlaceholder: 'Nombre del piloto',
  coDriver: 'Co-Piloto',
  coDriverNamePlaceholder: 'Nombre del co-piloto',
  team: 'Equipo',
  teamNamePlaceholder: 'Nombre del equipo',
  allowChooseStart: 'Permitir elegir posición de salida',
  priorityPilot: 'Piloto prioritario',
  timeSec: 'Tiempo (seg)',

  // AddParticipantModal
  addParticipantTitle: 'Añadir Participante',
  add: 'Añadir',

  // EditParticipantModal
  editParticipantTitle: 'Editar Participante',
  save: 'Guardar',

  // ConfigModal
  configTitle: 'Configuración',
  eventName: 'Nombre del evento',
  showTime: 'Mostrar tiempo del participante',
  showCodriver: 'Mostrar co-piloto',
  showTeam: 'Mostrar equipo',
  allParticipantsVisible: 'Todos los participantes visibles antes de elegir',
  language: 'Idioma',
  close: 'Cerrar',

  // RaceConfigModal
  loadFromAnubeTitle: 'Importar desde Anube',
  raceNumber: 'Número de carrera',
  raceNumberPlaceholder: 'ej. 305',
  loading: 'Cargando…',
  load: 'Cargar',
  loadError: 'Error al cargar. Verifique el número de carrera.',
  itinerary: 'Itinerario',
  specialStage: 'Especial / Tramo',
  applyAndFetch: 'Aplicar y Cargar',

  // Priority pilots field
  priorityPilotsLabel: 'Pilotos prioritarios (por número)',
  priorityPilotsPlaceholder: 'ej. 201, 37, 5',
  priorityPilotsHint: 'Lista separada por comas de números de vehículo que se marcarán como pilotos prioritarios.',

  // Max participants
  maxParticipantsLabel: 'Participantes a importar',

  // FIA Rules
  useFiaRules: 'Usar Reglas FIA Sección 33.1.1',

  // Finish message
  startSelectionFinished: '¡Selección de posiciones de salida finalizada!',
};
export default translations;